import * as Actions from "../actions";

const initialState = {
  loading: false,
  status: false,
  error: false,
  message: "",
  data: [],
  newAppLoading: false,
};
function application(state = initialState, action) {
  switch (action.type) {
    case Actions.ERR_GET_APPLICATION: {
      return {
        ...state,
        loading: false,
        status: false,
        message: action.payload.errorMessage,
        error: true,
      };
    }
    case Actions.GET_APPLICATION: {
      return {
        ...state,
        loading: false,
        status: true,
        data: [...action.payload],
        error: false,
      };
    }
    case Actions.ERR_CREATE_APPLICATION: {
      return {
        ...state,
        loading: false,
        status: false,
        message: action.payload.errorMessage,
        error: true,
        newAppLoading: false,
      };
    }
    case Actions.CREATE_APPLICATION: {
      return {
        ...state,
        loading: false,
        status: true,
        data: [action.payload.createApplication, ...state.data],
        error: false,
        newAppLoading: false,
      };
    }
    case Actions.NEW_APPLICATION_LOADING: {
      return {
        ...state,
        newAppLoading: true,
      };
    }
    case Actions.ERR_EDIT_APPLICATION: {
      return {
        ...state,
        loading: false,
        status: false,
        message: action.payload.errorMessage,
        error: true,
      };
    }
    case Actions.EDIT_APPLICATION: {
      const newState = state.data.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, ...action.payload };
        }
        return item;
      });
      return {
        ...state,
        loading: false,
        status: true,
        data: [...newState],
        error: false,
      };
    }
    case Actions.ERR_DELETE_APPLICATION: {
      return {
        ...state,
        loading: false,
        status: false,
        error: true,
      };
    }
    case Actions.CLEAR_APPLICATION: {
      return {
        ...state,
        data: [],
      };
    }
    case Actions.DELETE_APPLICATION: {
      const newState = state.data.filter((item) => item.id !== action.payload);
      return {
        ...state,
        loading: false,
        status: true,
        data: [...newState],
        error: false,
      };
    }
    default: {
      return state;
    }
  }
}
export default application;
